module.exports = __webpack_public_path__ + "static/apple-touch-icon-114x114-01a2ad59cbcb4008419c61b523aad6b2.png";